import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchResources } from "./resourceApi";

export const RESOURCES_QUERY_KEY = ["resources"];

export function useResources({ enabled = true } = {}) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: RESOURCES_QUERY_KEY,
    queryFn: fetchResources,
    enabled,
    staleTime: 30_000,
  });

  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: RESOURCES_QUERY_KEY });

  return {
    resources: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
    invalidate,
  };
}
